import antdData from 'antd/lib/locale-provider/fr_FR'
import localeData from 'react-intl/locale-data/fr'
import countries from './countries/fr.json'
import languages from './languages/fr.json'
import platform from './platform/fr.json'
import urls from './urls/fr.json'
import texts from './texts/fr.json'
import faq from './faq/fr.json'

export default {
  locale: 'fr',
  antdData,
  localeData,
  messages: { ...texts, ...countries, ...languages, ...platform, ...urls, ...faq },
}
